import NiceModal, { useModal } from "@ebay/nice-modal-react";
import { useState } from "react";
import { css } from "../../../../styled-system/css";
import { Center, VStack } from "../../../../styled-system/jsx";
import { Button } from "../../../components/core/basic/Button";
import { Modal } from "../../../components/core/basic/RACModal";
import { errorToast, successToast } from "../../../utils/toasts";
import { useRemoveProductsFromPlan } from "../api/useRemoveProductsFromPlan";

interface Props {
  selectedProducts: number[];
  productById: Record<number, { sku: string }>;
  onRemove: () => void;
}

const RemoveProductsFromPlanModal = NiceModal.create(({ selectedProducts, productById, onRemove }: Props) => {
  const modal = useModal();
  const [isConfirming, setIsConfirming] = useState(false);
  const removeProductsMutation = useRemoveProductsFromPlan();

  return (
    <Modal
      isOpen={modal.visible}
      isDismissable
      onOpenChange={(isOpen) => (isOpen ? void 0 : modal.remove())}
      title={"Remove Products from Pricing Plans"}
    >
      <VStack paddingX="large">
        {isConfirming && <p>The products will be removed</p>}

        {!isConfirming && (
          <>
            <h4 className={css({ margin: 0 })}>You will remove these products from their active pricing plans.</h4>

            <ul>
              {selectedProducts.slice(0, 5).map((id, i) => (
                <li key={i}>{productById[id]?.sku}</li>
              ))}
              {selectedProducts.length > 5 && <span> plus {selectedProducts.length - 5} more</span>}
            </ul>

            <p>Do you want to continue?</p>
          </>
        )}
        <Center gap="medium">
          <Button variant="secondary" onPress={() => modal.remove()}>
            Cancel
          </Button>

          <Button
            isPending={removeProductsMutation.isPending}
            onPress={() => {
              if (isConfirming) {
                removeProductsMutation.mutate(
                  { product_ids: selectedProducts },
                  {
                    onSuccess: () => {
                      onRemove();
                      successToast({
                        title: "Products removed",
                        message: "The products have been removed from their pricing plans.",
                      });
                      modal.remove();
                    },
                    onError: (error) => {
                      errorToast({
                        title: "Error removing products",
                        error,
                      });
                    },
                  },
                );
              } else {
                setIsConfirming(true);
              }
            }}
          >
            Remove Products
          </Button>
        </Center>
      </VStack>
    </Modal>
  );
});

export default RemoveProductsFromPlanModal;
